import React, { Component } from "react";
import './physicalassethome.css'
import { t } from "i18next";
import OtherPhysicalAsset from "../../../assets/svgs/physicalasset/other_physical_asset_home.svg";
import {
  BreadCrumb,
  Button,
  TitleView, SideModel
} from '../../components';
import * as Bl from "../../../businesslogic";
import {
  FIXED_ASSETS_TYPE,
} from "../../constants";
import { getUserId } from "../../common";
import { getInvestmentPhysicalPath } from "../../common";

const newFixedAssets = {
  fixedassettype: FIXED_ASSETS_TYPE.OTHER_PHY_ASSETS,
  currentvalue: 0,
  fixedassetdescription: "",
  assetinflation: 0,
  targetliquidationyear: 0,
  userid: "",
  expectedliquidationvalue: 0,
  isrented: false,
  assetdetails: [],
  fixedassetuuid: getUserId(),
  isliquidated: false,
  fvatretirement: 0,
  targetliquidationage: 0,
  isincludefinancialplan: false
};
class PhysicalAssetHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newFixedAssetsData: new Bl.FixedAsset({...newFixedAssets, userid: getUserId()}),
      fixedAssetData: [],
    }
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddProperty() {
    this.props.navigate('/physicalassetdetail', {
      state: { fixedAssetsData: this.state.newFixedAssetsData, isEditView: false },
    });
  }


  renderNavView() {
    const items = getInvestmentPhysicalPath("OtherPhysicalAssets");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsPA4");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="pah_profile_view">

        <img src={OtherPhysicalAsset} alt={t("networthAssetsPA3")} className="pah_icon" />
        <div className="pah_add_property">
          <Button
            buttonName={t("opaButton")}
            onPressButton={this.onPressAddProperty.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }

  renderContentView() {
    return (
      <div className='pah_content_view'>
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    )
  }

  render() {
    return (
      <div className="pah_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default PhysicalAssetHome;
